import React, {useEffect, useState} from "react";
import {User, WorkOrder} from "../types";
import DatePicker from "react-datepicker";
import {getUsers} from "../api/dataService";
import {Navigate} from "react-router-dom";
import Select from "react-select";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Alert, Button} from "react-bootstrap";
import {fetchFile} from "../api/api";


interface ExportTimeProps {
    endpoint?: string,
    workorderList?: WorkOrder[]
}

const formatDateString = (date: Date) => date.toLocaleDateString('en-CA');

const parseDateString = (value?: string) => {
    if (!value) {
        return undefined;
    }
    const [year, month, day] = value.split('-').map(Number);
    if (!year || !month || !day) {
        return undefined;
    }
    return new Date(year, month - 1, day);
};

const ExportTimecard: React.FC<ExportTimeProps> = (props) => {
    const [start, setStart] = useState<string>()
    const [end,setEnd] = useState<string>()
    const [emp, setEmp] = useState<string[]>([])
    const [wo, setWO] = useState<string[]>([])
    const [empList, setEmpList] = useState<User[]>([])
    const [errorMessage, setErrorMessage] = useState<string>();

    useEffect(() => {
        Promise.all([getUsers(undefined,'?is_active=true')])
            .then(([userResponse]) => {
                if('redirectTo' in userResponse) { return(<Navigate to={userResponse.redirectTo}/>)}
                if(Array.isArray(userResponse)){ setEmpList(userResponse) }
            })
    }, []);

    const handleExport = () => {
        const endpoint = props.endpoint;
        if (!endpoint) {
            setErrorMessage('No export endpoint configured.');
            return;
        }

        const params = new URLSearchParams();
        if (start) { params.set('start_date_after', start); }
        if (end) { params.set('start_date_before', end); }
        if (emp.length > 0) { params.set('employee_id_in', emp.join(',')); }
        if (wo.length > 0) { params.set('workorder', wo.join(',')); }
        params.set('format', 'csv');

        const filters = `?${params.toString()}`;
        fetchFile(endpoint, undefined, filters);
        setErrorMessage(undefined)
    }
    return (
        <Container>
            {errorMessage && (
                <Alert variant="danger">
                    {errorMessage}
                </Alert>
            )}
            <Row className={'mb-3'}>
                <label id={'employeeuser_set'}>
                    Employee
                </label>
                <Select
                    isMulti={true}
                    name="employeeuser_set"
                    options={empList.map(entry => ({
                        label: `${entry.last_name}, ${entry.first_name}`,
                        value: entry.id,
                    })).sort((a, b) => a.label.localeCompare(b.label))}
                    placeholder={'Select an Employee...'}
                    onChange={(selectedOption) => {
                        const selectedEmpIds: string[] = []
                        selectedOption.forEach((selection) => {
                            selectedEmpIds.push(selection.value)
                        })
                        setEmp(selectedEmpIds)
                    }}
                />
            </Row>
            <Row>
                <label id={'workorder_set'}>
                    Work Order
                </label>
                {
                    props.workorderList ? (
                        <>
                            <Select
                                isMulti={true}
                                name="workorder_set"
                                options={props.workorderList.map(entry => ({
                                    label: `WO #${entry.id}, Client Name ${entry.billing_client}`,
                                    value: entry.id
                                })).sort((a,b) => b.label.localeCompare(a.label))}
                                placeholder={'Select an Work Order...'}
                                onChange={(selectedOption) => {
                                    const selectedWOIds: string[] = []
                                    selectedOption.forEach((selection) => {
                                        selectedWOIds.push(selection.value)
                                    })
                                    setWO(selectedWOIds)
                                }}
                            />
                            <div className={'text-warning small mt-1'}>
                                Selecting a work order excludes lunch breaks from the export.
                            </div>
                        </>
                    ) : <></>
                }

            </Row>
            <Row className={'mb-3'}>
                <Col className={'justify-content-center'}>
                    <p id={'start_date'}>
                        Start Date
                    </p>
                    <DatePicker
                        id="start_date"
                        className={'datetime-select form-control'}
                        dateFormat={"yyyy-MM-dd"}
                        selected={
                            parseDateString(start)
                        }
                        onChange={(date: Date) => {
                            if (date) {
                                setStart(formatDateString(date))
                            }
                        }}
                    />
                </Col>
                <Col className={'justify-items-center'}>
                    <p id={'end_date'}>
                        End Date
                    </p>
                    <DatePicker
                        id="end_date"
                        className={'datetime-select form-control'}
                        dateFormat={"yyyy-MM-dd"}
                        selected={
                            parseDateString(end)
                        }
                        onChange={(date: Date) => {
                            if (date) {
                                setEnd(formatDateString(date))
                            }
                        }}
                    />

                </Col>
            </Row>
            <Row className={'mb-3'}>
                <Button onClick={() => handleExport()}>
                    Export Timecard
                </Button>
            </Row>

        </Container>
    )

}

export default ExportTimecard
